function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Warning Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Warning",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Components-/-button-/-icon-/-primary-/-round-Copy"
}, React.createElement("g", {
  id: "\\u25A0-BG",
  fill: "#EA2027"
}, React.createElement("circle", {
  id: "Oval",
  cx: 15,
  cy: 15,
  r: 15
})), React.createElement("g", {
  id: "danger-(1)",
  transform: "translate(13.000000, 6.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M1.78847222,1.58368056 C0.907916667,1.58368056 0.220694444,2.05618056 0.220694444,2.89381944 C0.220694444,5.44951389 0.521319444,9.12201389 0.521319444,11.6777778 C0.521388889,12.3435417 1.10131944,12.6227083 1.78854167,12.6227083 C2.30395833,12.6227083 3.03416667,12.3435417 3.03416667,11.6777778 C3.03416667,9.12208333 3.33479167,5.44958333 3.33479167,2.89381944 C3.33479167,2.05625 2.62611111,1.58368056 1.78847222,1.58368056 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M1.81006944,14.1045833 C0.865138889,14.1045833 0.156319444,14.85625 0.156319444,15.7583333 C0.156319444,16.6388889 0.865069444,17.4120833 1.81006944,17.4120833 C2.690625,17.4120833 3.44236111,16.6388889 3.44236111,15.7583333 C3.44236111,14.85625 2.69055556,14.1045833 1.81006944,14.1045833 Z",
  id: "Warning Icon"
}))));

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.3fb3fc75.svg";
export { ForwardRef as ReactComponent };